export const selectAuth = (state) => state.auth;

export const selectAuthUser = (state) => selectAuth(state).user;
export const selectAuthProfiles = (state) => selectAuth(state).profiles;
export const selectAuthToken = (state) => selectAuth(state).token;
export const selectAuthIsFetching = (state) => selectAuth(state).isFetching;
export const selectAuthIsTeamOwner = (state) => selectAuth(state).isTeamOwner;
export const selectAuthOnboardStep = (state) => selectAuth(state).onboardStep;
export const selectAuthError = (state) => selectAuth(state).error;
